<template>
    <div class="cc">
        <!-- 签约步骤 -->
        <div class="cc-header">
            <div class="cc-icon">
                <div>
                    <div v-for="(v, i) in steps" class="cc-icon-t">
                        <common-icon :type="v.icon" :size="36" />
                        <span>{{ v.text }}</span>
                    </div>
                </div>
            </div>
        </div>
        <Spin fix v-if="loading" />
        <Form ref="info" :labelWidth="120" v-else>
            <!-- 合同信息 -->
            <contract-info
                prop="contract"
                :room="room"
                v-model="contract"
                class="contract-content-class"
                @onHouseChange="onHouseChange"
                @contract-tpl-select="onContractTplSelect"
            />
            <Divider />
            <!-- 租客信息 -->
            <customer-info
                prop="cus"
                v-model="cus"
                class="contract-content-class"
                :disabledUser="disabledUser"
                :isShowEditBtn="false"
                :isShowEditRecord="false"
            />
            <Divider />
            <!-- 租约信息 -->
            <lease-info
                prop="lease"
                v-model="lease"
                @on-create-bills="createBill"
                class="contract-content-class"
                :isBook="isBook"
            />
        </Form>
        <Divider />
        <!-- 账单信息 -->
        <bills-info
            :value="billView"
            class="contract-content-class"
            :loading="billLoading"
        />
        <div style="height: 100px"></div>
        <div class="btn-container">
            <Button style="margin-right: 10px" @click="submit" type="primary">
                确定提交
            </Button>
            <Button @click="view">预览合同</Button>
        </div>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showBillCorrection"
            title="账单修正"
            :width="1080"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="openCode"
        >
            <bill-correction v-if="modal.showBillCorrection" v-model="bills" />
        </smart-modal>
        <contract-create-success
            v-model="showSuccess"
            @cancelModal="createOnce"
            @confirmModal="toPark"
            :btnConfirm="createSuccessMsg"
        />
    </div>
</template>

<script>
import { deepCopy, officePreview } from '_u/helper'
import { formateContractAndView } from '_v/common/u-contract'
import mContract from '_v/common/m-contract'
import Dict from '_u/dict'

import ContractInfo from './children/contract-info'
import CustomerInfo from './children/customer-info'
import LeaseInfo from './children/lease-info'
import BillsInfo from './children/bills-info'
import BillCorrection from './bill-correction'
import ContractCreateSuccess from './contract-create-success'

import { contractPriview, contractAdd } from '@/api/contract'
import { assetsBookView, houseRelDetail } from '@/api/assets'

export default {
    name: 'ContractCreate',
    mixins: [mContract],
    components: {
        ContractInfo,
        CustomerInfo,
        LeaseInfo,
        BillsInfo,
        BillCorrection,
        ContractCreateSuccess,
    },
    data() {
        return {
            //
            loading: false, // 初始化loading
            billLoading: false, // 生成账单loading
            modal: {
                showBillCorrection: false,
            },
            showSuccess: false,
            disabledUser: false,
            //
            contract: {}, // 合同信息
            cus: {}, // 租客信息
            lease: {}, // 租约信息
            facility: [], // 合同设施
            bills: [], // 账单信息
            payBills: [], // 待付账单——存储待付账单——账单修正不显示，创建合同需要合并到bills
            billInfo: [], // 账单信息——账单修正
            billView: [], // 账单信息——账单显示
            isBook: false, // 房间是否为预定状态
            dict: {
                feeType: Dict.NULL,
            },
            formData: '',
            routerHouseId: this.$route.query.houseId, // 房间id
            routerForm: this.$route.query.from, // 合同入口
            room: {},
            entryContractType: '', // 合同类型
        }
    },
    computed: {
        // 根据来的地方，决定显示的文字
        createSuccessMsg() {
            let message = ''
            if (this.routerForm === 'assetsParkIndex') {
                message = '返回房源管理'
            } else if (this.routerForm === 'contractIndex') {
                message = '返回合同管理'
            }
            return message
        },
        // 说明步骤
        steps() {
            // prettier-ignore
            var list = [
                { icon: '_luruxinxi', text: '录入租客租约信息',},
                { icon: '_luruchenggong', text: '录入成功生成二维码',},
                { icon: '_saomatixing', text: '租客扫码获取提醒',},
            ]

            // 电子合同
            if (this.entryContractType == '1') {
                list.splice(1, 0, {
                    icon: '_qianyue',
                    text: '租客签字签约',
                })
            }

            return list
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([Dict.get(['fee_type'])]).then((args) => {
                var [dictGroup] = args

                Object.assign(this.dict, dictGroup)
                if (this.routerHouseId) {
                    this.onHouseChange(this.routerHouseId)
                } else {
                    this.loading = false
                }
            })
        },
        // 选中合同模板
        onContractTplSelect(e) {
            this.entryContractType = e.tplType
        },
        // 房间更改，租约信息更改
        onHouseChange(houseId) {
            var action = houseId
                    ? houseRelDetail(houseId).then((res) => res.data.map)
                    : Promise.resolve({}),
                room = {}

            action
                .then((res) => (room = res))
                .then(() => {
                    if (room.houseStatus === '2') {
                        return assetsBookView(houseId)
                    } else {
                        return Promise.resolve()
                    }
                })
                .then((res) => {
                    if (res) {
                        room.cusId = res.data.entity.cusId
                        room.cusMobile = res.data.entity.cusMobile
                        room.cusName = res.data.entity.cusUser
                        room.receiveStatus = res.data.entity.receiveStatus
                        room.resAmount = res.data.entity.resAmount
                    }
                    this.room = room
                    this.setRoomData(room)
                })
                .finally(() => (this.loading = false))
        },
        // 根据房间信息，把对应的数据带过来
        setRoomData(room) {
            var lease = {
                buildArea: room.buildArea || '',
                depositPayMethod: room.depositPayMethod || '',
                rentPayMethod: room.rentPayMethod || '',
                unitPrice: room.unitPrice / 100 || '',
                rent: room.rent / 100 || '',
                deposit: room.deposit / 100 || '',
                resAmount: room.resAmount / 100 || '',
                minPrice: room.minPrice / 100 || '',
                receiveStatus: room.receiveStatus || '',
                fList: room.faclityList || [],
                otherFee: room.otherFeeList || [],
                otherDeposit: room.otherDepositList || [],
            }

            lease.fList.forEach((v) => (v.price /= 100))
            lease.otherFee.forEach((v) => (v.amount /= 100))
            lease.otherDeposit.forEach((v) => (v.amount /= 100))
            this.lease = lease

            // 读取预定信息
            if (room.houseStatus === '2') {
                this.isBook = true
                this.cus = {
                    cusId: room.cusId,
                    cusType: room.cusType,
                    cusMobile: room.cusMobile,
                    cusName: room.cusName,
                    comName: room.cusName,
                }
                this.disabledUser = true
            } else {
                this.isBook = false
                //需求变更，此时不置空客户信息
                // this.cus = {
                //     cusId: '',
                //     cusMobile: '',
                //     cusName: '',
                // }
                this.disabledUser = false
            }
        },
        // 提交-显示修改账单
        submit() {
            this.$refs.info
                .validate()
                .then(() => {
                    this.modal.showBillCorrection = true
                })
                .catch((err) => {
                    this.$Message.error(err[0].message)
                })
        },
        // 预览合同
        view() {
            this.$refs.info
                .validate()
                .then(() => {
                    const data = deepCopy(this.$refs.info.populateData())
                    formateContractAndView(data)
                    const formData = {
                        contract: JSON.stringify(data.contract),
                        cus: JSON.stringify(data.cus),
                        lease: JSON.stringify(data.lease),
                        bills: JSON.stringify(this.bills),
                        facility: JSON.stringify(data.facility),
                    }
                    contractPriview(formData).then((res) => {
                        window.open(officePreview(res.data.path))
                    })
                })
                .catch((err) => {
                    this.$Message.error(err[0].message)
                })
        },
        // 创建账单
        createBill() {
            const data = this.$refs.info.populateData()
            const formData = deepCopy(data.lease)
            if (!formData) return
            this.createContractBill(formData)
        },
        // 合同创建
        contractCreate() {
            const data = deepCopy(this.$refs.info.populateData())
            this.formatePopulateData(data)
            const formData = {
                contract: JSON.stringify(data.contract),
                cus: JSON.stringify(data.cus),
                lease: JSON.stringify(data.lease),
                facility: JSON.stringify(data.facility),
                bills: JSON.stringify(data.bills),
            }
            return contractAdd(formData)
        },
        // 格式化
        formatePopulateData(data) {
            formateContractAndView(data)
            data.bills = deepCopy(this.bills.concat(this.payBills))
            data.bills.forEach((v) => {
                v.title = ''
                v.periodText = ''
                v.bill = ''
            })
        },
        // 二维码
        openCode() {
            this.contractCreate().then(() => {
                this.$Message.success(this.$t('tips.add.success'))
                this.showSuccess = true
            })
        },
        // 重新录制
        createOnce() {
            this.showSuccess = false
            this.$router.go(0)
        },
        // 返回房源管理或合同管理
        toPark() {
            this.showSuccess = false
            this.$router.push({
                name: this.routerForm,
            })
        },
    },
}
</script>

<style lang="less" scoped>
.cc {
    // 头部icon
    &-header {
        padding: 32px 0px 48px;
        text-align: center;
    }
    &-icon {
        display: inline-block;
        &-t {
            display: inline-block;
            margin: 0 70px;
            position: relative;
            background-color: @primary-color;
            color: #ffffff;
            border-radius: 50%;
            padding: 18px;
            &:first-child {
                margin-left: 20px;
                &::before {
                    width: 0;
                }
            }
            &:last-child {
                margin-right: 20px;
                &::after {
                    width: 0;
                }
            }
            &::before {
                content: '';
                display: inline-block;
                width: 50px;
                height: 1px;
                position: absolute;
                top: 50%;
                left: -70px;
                margin-top: -1px;
                background: @border-color-base;
            }
            &::after {
                content: '';
                display: inline-block;
                width: 50px;
                height: 1px;
                position: absolute;
                top: 50%;
                left: 92px;
                margin-top: -1px;
                background: @border-color-base;
            }

            span {
                width: 200px;
                margin-left: -100px;
                position: absolute;
                left: 50%;
                bottom: -32px;
                display: inline-block;
                text-align: center;
                color: #333333;
                font-size: 14px;
            }
        }
    }
}
</style>
